import { render, staticRenderFns } from "./LecturaInspeccion.vue?vue&type=template&id=b2a88c52&"
import script from "./LecturaInspeccion.vue?vue&type=script&lang=js&"
export * from "./LecturaInspeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports